import { render, staticRenderFns } from "./footer-section.vue?vue&type=template&id=93241600&scoped=true"
import script from "./footer-section.vue?vue&type=script&lang=js"
export * from "./footer-section.vue?vue&type=script&lang=js"
import style0 from "./footer-section.vue?vue&type=style&index=0&id=93241600&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93241600",
  null
  
)

export default component.exports